import { render } from "./ModalCreateUpdate.vue?vue&type=template&id=46a67f56&scoped=true"
import script from "./ModalCreateUpdate.vue?vue&type=script&lang=js"
export * from "./ModalCreateUpdate.vue?vue&type=script&lang=js"

import "./ModalCreateUpdate.vue?vue&type=style&index=0&id=46a67f56&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a67f56"]])

export default __exports__